// extracted by mini-css-extract-plugin
export default {"color-filter-purple":"#8735EA","colorFilterPurple":"#8735EA","color-grey-2":"#C2C2C2","colorGrey2":"#C2C2C2","colorPill":"_1V7YI"};